module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-form-page membership-form-page"
  }, [_c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account payment-form-card membership-form-card"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_edit_payment')))]), _vm._v(" "), (_vm.additionalTypes.length > 0) ? _c('div', {
    staticClass: "scrollmenu section-bottom-sm membership-form-chip-row"
  }, [_c('span', {
    staticClass: "form-subtitle"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_types')) + ": ")]), _vm._v(" "), _vm._l((_vm.paymentTypes), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          _vm.model.additionalService = item.value
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipTypeClass(item)
    }, [_vm._v(_vm._s(_vm.isSelectedType(item) ? '✔ ' : '') + _vm._s(item.label))])])]), _vm._v(" \n                            ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_ci_position')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.orderNumber),
      expression: "model.orderNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_ci_position'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "orderNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('i', {
    staticClass: "form-hint-text"
  }, [_vm._v("*" + _vm._s(_vm.locale.t('label_ci_position_desc')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_mp_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center payment-form-section-title membership-form-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_add_category_membership')) + " "), _c('div', {
    staticClass: "new-button membership-form-plus",
    on: {
      "click": function($event) {
        return _vm.openAddMembershipCategory()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus clickable"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_category_membership')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.category),
      expression: "model.category"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.categories), function(item) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                                      " + _vm._s(item) + "\n                                    ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_during_in_days')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.durationInDays),
      expression: "model.durationInDays"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_mp_during_in_days'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.durationInDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "durationInDays", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_num_trainings')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.trainingNumber),
      expression: "model.trainingNumber"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_payment_num_trainings'),
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.trainingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "trainingNumber", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center payment-form-section-title membership-form-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')) + " "), _c('i', {
    staticClass: "ti-plus clickable membership-form-plus-icon",
    on: {
      "click": function($event) {
        return _vm.openTrainingTypes()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-types membership-form-checklist"
  }, [_c('ul', {
    staticClass: "checkbox-list"
  }, _vm._l((_vm.types), function(key) {
    return _c('li', {
      key: key
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "value": key,
        "checked": _vm.setSelectedCheckBox(key)
      },
      on: {
        "click": function($event) {
          return _vm.onChangeCheckBox(key)
        }
      }
    }), _vm._v("\n                                  " + _vm._s(key) + "\n                                ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_price')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.price),
      expression: "model.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "number",
      "placeholder": _vm.locale.t('label_mp_price'),
      "name": "treninzi"
    },
    domProps: {
      "value": (_vm.model.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "price", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.showMembershipType) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_membership_type')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.membershipType),
      expression: "model.membershipType"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.model, "membershipType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.membershipTypes), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                                      " + _vm._s(item.label) + "\n                                    ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_action')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enableAction),
      expression: "model.enableAction"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.locale.t('label_mp_action'),
      "name": "treninzi"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.enableAction) ? _vm._i(_vm.model.enableAction, null) > -1 : (_vm.model.enableAction)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.enableAction,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "enableAction", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "enableAction", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "enableAction", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), (_vm.showMemberShipForProgram) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_for_program')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.forProgram),
      expression: "model.forProgram"
    }],
    staticClass: "ui-checkbox",
    attrs: {
      "type": "checkbox",
      "placeholder": _vm.locale.t('label_mp_for_program'),
      "name": "treninzi"
    },
    domProps: {
      "checked": Array.isArray(_vm.model.forProgram) ? _vm._i(_vm.model.forProgram, null) > -1 : (_vm.model.forProgram)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.model.forProgram,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.model, "forProgram", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.model, "forProgram", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.model, "forProgram", $$c)
        }
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "text-center payment-form-section-title membership-form-section-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_payment_equipment')) + " "), _c('i', {
    staticClass: "ti-plus clickable membership-form-plus-icon",
    on: {
      "click": function($event) {
        return _vm.openAdditionalKit()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "payment-types membership-form-checklist"
  }, [_c('ul', {
    staticClass: "checkbox-list"
  }, _vm._l((_vm.allKits), function(key) {
    return _c('li', {
      key: key
    }, [_c('label', {
      attrs: {
        "for": key
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "value": key,
        "checked": _vm.setSelectedCheckBoxKits(key)
      },
      on: {
        "click": function($event) {
          return _vm.onChangeCheckBoxKits(key)
        }
      }
    }), _vm._v("\n                                  " + _vm._s(key) + "\n                                ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button membership-form-save",
    on: {
      "click": _vm.editMembership
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n                                        ")])])])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-time"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-view-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-time"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-view-list"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-arrow-up"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41746e11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Membership/EditMembership/EditMembership.vue
// module id = 751
// module chunks = 0